import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputDateNotMinorErrorMessage = (
  <Trans>
    La personne doit être mineure
  </Trans>
);
